import { getTaskTitle } from './helper';

export const tasksTableData = (tasks) =>
  tasks?.map((task) => {
    const prospect = [];

    if (task?.prospect?.firstName) {
      prospect.push({
        id: task?.prospect?.id,
        value: task?.prospect?.firstName,
        label: 'First Name',
        isDefault: true,
      });
    }

    if (task?.prospect?.lastName) {
      prospect.push({
        id: task?.prospect?.id,
        value: task?.prospect?.lastName,
        label: 'Last Name',
        isDefault: true,
      });
    }

    if (task?.prospect?.email) {
      prospect.push({
        id: task?.prospect?.id,
        value: task?.prospect?.email,
        label: 'Email',
        isDefault: true,
      });
    }

    const stepNumber = task?.sequenceProspectTask?.step?.number;
    const sequenceName = task?.sequenceProspectTask?.step?.sequence?.title;

    return {
      id: task?.id,
      type: task?.type,
      prospect,
      taskTitle: {
        type: task?.type,
        title:
          task?.taskPayload?.payload?.title ||
          getTaskTitle(task?.type, task?.taskPayload?.payload?.purpose),
      },
      sequence: {
        stepNumber,
        sequenceName: task?.sequence?.title,
        sequenceId: task?.sequence?.id,
        sequenceType: task?.sequence?.type,
        parentSequenceId: task?.sequence?.parentSequenceId,
        progress: task?.sequence?.progress,
      },
      priority: task?.priority,
      date: {
        dueAt: task?.dueAt,
        skippedAt: task?.skippedAt,
        processedAt: task?.processedAt,
        completedAt: task?.completedAt,
      },
      owner: {
        taskId: task.id,
        firstName: task?.assignee?.firstName,
        lastName: task?.assignee?.lastName,
        taskType: task?.type,
      },
      callOutcome: task?.metadata?.callOutcome,
      hashId: task?.hashId,
      failedReason: task?.linkedInTaskError?.errorCode,
      prospectId: task?.prospect?.id,
      missingFields: task?.linkedInTaskError?.missingFields,
      fieldMappings: task?.linkedInTaskError?.fieldMappings,
      platform: task?.linkedInTaskError?.platform,
      rawApiError: task?.linkedInTaskError?.errorMessage,
      prospectOutcome: task?.sequenceProspectTask?.sequenceProspect
        ? {
            categoryId:
              task?.sequenceProspectTask?.sequenceProspect?.categoryId,
            name: task?.sequenceProspectTask?.sequenceProspect?.category?.name,
            sentiment:
              task?.sequenceProspectTask?.sequenceProspect?.category?.sentiment,
            isDefault: true,
          }
        : null,
    };
  });
